import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  //Resets' inspiration: https://www.joshwcomeau.com/css/custom-css-reset/#the-css-reset
  html, body {
    height: 100%;
  }

  img {
    max-width: 100%;
  }
`;

export default GlobalStyle;
